import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SharePhotoForm"] */ "/vercel/path0/src/app/masjids/shaheed/[slug]/share-photo/SharePhotoForm.tsx");
